import AppHeader from '../AppHeader'

export default {
  name: 'stock',
  async created () {
    window.sessionStorage.removeItem('master_consumable_item_search')
    const res = await this.$store.dispatch('STOCK_CHECK_PERIOD')
    this.isStockCheckPeriod = res.data
  },
  data () {
    return {
      isStockCheckPeriod: false
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stock.js